<template>
    <div>
      <v-btn :class="{'microphone-active': !microphoneMuted}" icon @click="toggleMicrophone" class="microphone-button">
        <v-icon>{{ microphoneMuted ? 'mdi-microphone-off' : 'mdi-microphone' }}</v-icon>
      </v-btn>
    </div>
</template>
  
<script>
  export default {
    props: {
      targetModel: {
        type: String,
        required: true,
      },
    },
    data() {
      return {
        recognition: null,
        microphoneMuted: true,
      };
    },
    methods: {
      toggleMicrophone() {
        if (this.microphoneMuted) {
          this.startRecognition();
        } else {
          this.stopRecognition();
        }
        this.microphoneMuted = !this.microphoneMuted;
      },
      startRecognition() {
        if (!('webkitSpeechRecognition' in window) && !('SpeechRecognition' in window)) {
          alert('Seu navegador não suporta reconhecimento de voz. Por favor, use o Google Chrome.');
          return;
        }
  
        this.recognition = new (window.SpeechRecognition || window.webkitSpeechRecognition)();
        this.recognition.continuous = true;
        this.recognition.interimResults = true;
        this.recognition.lang = 'pt-BR';
  
        this.recognition.onstart = () => {
          console.log('Reconhecimento de voz iniciado');
        };
  
        this.recognition.onresult = (event) => {
          let transcript = '';
          for (let i = event.resultIndex; i < event.results.length; ++i) {
            transcript += event.results[i][0].transcript;
          }
          this.$emit('update:targetModel', transcript);
        };
  
        this.recognition.onerror = (event) => {
          console.error('Erro no reconhecimento de voz:', event.error);
          if (event.error === 'not-allowed') {
            alert('Permissão para usar o microfone foi negada. Por favor, conceda permissão para continuar.');
          }
          this.microphoneMuted = true;
        };
  
        this.recognition.onend = () => {
          console.log('Reconhecimento de voz terminado');
          this.microphoneMuted = true;
        };
  
        this.recognition.start();
      },
      stopRecognition() {
        if (this.recognition) {
          this.recognition.stop();
        }
      },
    },
    beforeDestroy() {
      this.stopRecognition();
    },
  };
  </script>
  
  <style scoped>
  @keyframes pulse {
    0% {
      transform: scale(1);
      color: #6c757d;
    }
    50% {
      transform: scale(1.5);
      color: #0099dd;
    }
    100% {
      transform: scale(1);
      color: #6c757d;
    }
  }
  
  .microphone-button {
    margin-top: 10px;
  }
  
  .microphone-active {
    animation: pulse 1s infinite;
  }
</style>
